import { useState } from 'react'

export const useModal = () => {
  const [viewModal, setViewModal] = useState(false)

  return { setViewModal, viewModal }
}
